import React, { Component } from 'react';
import { MenuItem } from '@material-ui/core';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import RenameSheetDialog from './RenameSheetDialog';

class RenameSheet extends Component {
  constructor(props) {
    super(props);
    this.store = observable({
      open: false,
      // listName: props.list.name
    });
  };

  handleClickOpen = () => {
    this.store.open = true;
  }

  handleClose = () => {
    // this.store.listName = this.props.list.name;
    this.store.open = false;
  }

  // handleSave = () => {
  // this.props.onChange(this.store.listName);
  // this.handleClose();
  // }


  render() {
    return (
      <React.Fragment>
        <MenuItem onClick={this.handleClickOpen}>
          Rename Sheet
        </MenuItem>
        {
          this.store.open &&
          <RenameSheetDialog list={this.props.list} open={this.store.open}  onClose={this.handleClose} onChange={this.props.onChange} />
        }
      </React.Fragment>
    );
  }
}

export default observer(RenameSheet);